const SWATCHES = "color-swatches";
const SWATCH = "color-swatches-swatch";
const ADD_CUSTOM_COLOR_BUTTON = "add-custom-color-button";
const RESET_COLOR_BUTTON = "reset-color-button";
export {
  ADD_CUSTOM_COLOR_BUTTON,
  RESET_COLOR_BUTTON,
  SWATCH,
  SWATCHES
};
//# sourceMappingURL=data-hooks.js.map
